import { defineStore } from 'pinia'
import { cryptoAES } from '@/utils/cryptoUtil'
import crypto from '@/utils/crypto'
import {singleSlashPath} from '@/utils/jsonUtil'
// let searchDomain = 'https://search.483898.lol'
// if (process.client) {
//   const currentHostname = window.location.hostname
//   if (currentHostname === 'localhost' || location.origin.includes('test')) {
//     searchDomain = 'http://test.mediasearch.dfre45.com'
//   }else if(window.location.hostname.includes('034630.com')){
//     searchDomain = 'https://search.034630.com'
//   }
// }
const cryptoAesKey = 'zH3JDuCRXVGa3na7xbOqpx1bw6DAkbTP'
interface searchState {
  keyWords: string
  resultKeywords: string
  showRecommends: boolean

  defaultTypes: any
  resultTypes: any
  activeChannel: number | string
  activeType: number | string
  isSearched: boolean
  defaultData: any
  resultData: any
  loading: boolean
  finished: boolean
  relatedData: any
  isRequested: boolean
  pageNo: number
  pageSize: number
  pageCount: number
  isFilterStatus: boolean
  sortValue: any
  isFirstLoad: any
  scrollToTop: Function
}
export const useSearchStore = defineStore('searchStore', {
  state: (): searchState => {
    return {
      keyWords: '',
      resultKeywords: '',
      showRecommends: false,
      defaultTypes: [],
      resultTypes: [
        { name: '最新上传', id: 3 },
        { name: '最多播放', id: 4 },
        { name: '最多点赞', id: 'like' },
        { name: '高清', id: 1 },
        { name: '超清', id: 2 }
      ],
      activeChannel: 1,
      activeType: 1,
      isSearched: false,
      defaultData: [],
      resultData: [],
      loading: false,
      finished: false,
      relatedData: [],
      isRequested: false,
      pageNo: 1,
      pageSize: 50,
      pageCount: 0,
      isFilterStatus: false,
      sortValue: '',
      isFirstLoad: true,
      scrollToTop: () => {}
    }
  },
  actions: {
    clearKeywords() {
      this.relatedData = []
      this.keyWords = ''
      this.isSearched = false
    },
    setPageNo(page: number) {
      this.pageNo = page
    },
    searchRelated() {
      const { isNanTong }: any = storeToRefs(useGlobalStore())
      if (this.keyWords.length < 2) {
        return
      }
      const base = useGlobalStore().currtSearchDomain?.url ?? ''
      const suffix = isNanTong.value ? 'search-gay/related' : 'search/related'
      const searchUrl = `${base}/${suffix}`
      // useGlobalStore().currtSearchDomain?.url + `/search${isNanTong.value ? '-gay' : ''}/related`

      $fetch(singleSlashPath(searchUrl), {
        params: {
          text: crypto.encryptAES(this.keyWords, 'zH3JDuCRXVGa3na7xbOqpx1bw6DAkbTP') // crypto.aesKey,
        }
      })
        .then(async (res: any) => {
          // console.log(res, 'res')
          //this.finished = true
          this.showRecommends = true

          if (res) {
            const jsonData = JSON.parse(crypto.decryptAES(res.json_data, cryptoAesKey))
            jsonData.forEach((item: any) => {
              let txt = item.title
              item.htmlTxt = txt.replace(new RegExp(`(${this.keyWords})`, 'gi'), '<span class="highlight">$1</span>')
            })
            this.relatedData = jsonData
          } else {
            this.relatedData = []
          }
        })
        .catch((e) => {
          console.log(e)
          showToast('当前系统访问繁忙，请稍后使用搜索功能')
          // this.finished = true
        })
    },
    loadMore(isSearchClicked = false, options: any) {
      const { isNanTong }: any = storeToRefs(useGlobalStore())
      let encrytText = cryptoAES.encrypt(this.keyWords)

      let uri = isNanTong.value ? '/search-gay/filter' : '/search/filter'
      let query: any = {
        size: this.pageSize,
        sortValue: this.sortValue,
        text: encrytText,
        current: this.pageNo
      }
      if (this.isFilterStatus) {
        uri = isNanTong.value ? '/search-gay/filter' : '/search/filter'
        query.date = options?.currentDate.value
        query.quality = options?.currentClarity.value
        query.duration = options?.currentDuration.value
      }
      uri += '?f=2'
      if (this.finished) return
      this.isRequested = true
      $fetch(singleSlashPath(useGlobalStore().currtSearchDomain?.url + uri), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json' // 指定数据类型为 JSON
        },
        body: JSON.stringify(query)
      })
        .then(async (res: any) => {
          let decryptData = cryptoAES.decryptJson(res)

          if (!Array.isArray(decryptData)) {
            decryptData = []
          }

          this.resultData = decryptData
          this.sortValue = res.sortValue
          if (res?.ended) {
            this.finished = true
          } else {
            this.finished = false
          }
        })
        .catch((error) => {
          console.log(error)
          showToast('当前系统访问繁忙，请稍后使用搜索功能')
          this.finished = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 分页打开
    async searchMain(text?: string, success?: Function) {
      this.pageNo = 1;
      this.isFirstLoad = false
      this.isFilterStatus = false
      this.sortValue = ''
      this.relatedData = []
      this.resultData = []
      if (text) {
        this.keyWords = text
      }
      if (!this.keyWords) {
        return
      }
      this.trackClklogSearchClick(this.keyWords)
      useTypesStore().$reset()
      this.resultKeywords = this.keyWords
      let encrytText = cryptoAES.encrypt(this.keyWords)
      const { isNanTong }: any = storeToRefs(useGlobalStore())
      const base = useGlobalStore().currtSearchDomain?.url ?? ''
      const suffix = isNanTong.value ? 'search-gay/filter' : 'search/filter'
      const searchUrl = `${base}/${suffix}?f=3`

      this.loading = true
      $fetch(singleSlashPath(searchUrl), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json' // 指定数据类型为 JSON
        },
        body: JSON.stringify({
          text: encrytText,
          // sortValue: this.sortValue,
          size: this.pageSize,
          current: this.pageNo
        })
      })
        .then(async (res: any) => {
          if(this.scrollToTop){
            setTimeout(this.scrollToTop,100);
          }
          
          this.isRequested = true

          let decryptData = cryptoAES.decryptJson(res)
          if (Array.isArray(decryptData)) {
            this.resultData = decryptData
          } else {
            this.resultData = []
          }
          this.pageCount = Math.ceil(res.total / this.pageSize)
          this.sortValue = res.sortValue
          if (res.ended) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (success) success()
        })
        .catch(() => {
          showToast('当前系统访问繁忙，请稍后使用搜索功能')
          this.finished = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    // clklog 搜索打点统计
    trackClklogSearchClick(text: string) {
      let win: any = window
      if (win.sensors && text) {
        win.sensors.track('SearchClick', {
          search_content: text,
          origin_host: window.location.origin
        })
      }
    }
  }
  // 开始数据持久化
  // persist: process.client && {
  //   key: 'searchData',
  //   storage: process.client && window.localStorage
  // }
})
